import axios from "axios";

function getTimes() {
    let data = new Date()
    let year = data.getFullYear().toString()
    let month = data.getMonth()+1
    return year+ month+  data.getDate()+ data.getHours()+ data.getMinutes() + data.getSeconds()
}

export async function ossUpload(file, ossToken, type, arr,type_info) {
    let filename = ''
    if(type_info=='ideas_name'){
        filename = getTimes() +'_'+ file.name;
    }else {
        filename = getTimes();
    }
    // getTimes() +'_'+ file.name;
    // const filename = getTimes();
    let formData = new FormData();
    //注意formData里append添加的键的大小写
    formData.append("key", ossToken.dir + filename); //存储在oss的文件路径
    formData.append("OSSAccessKeyId", ossToken.accessid); //accessKeyId
    formData.append("policy", ossToken.policy); //policy
    formData.append("Signature", ossToken.signature); //签名
    formData.append("success_action_status", 200); //成功后返回的操作码
    //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
    formData.append("file", file);
    await axios.post(ossToken.host, formData, {
        "Content-Type": "multipart/form-data",
        // "Content-Type": "image/jpg",
    }).then((res) => {
        if (res.status == 200) {
            let imgurl = `${ossToken.host2}/${ossToken.dir}${filename}`;
            if (type == "one") {
                arr = [];
                arr.push(imgurl);
            } else {
                arr.push(imgurl);
            }
        }
    });
    return arr;
}

export function downloadFile(urlName, filename){
    axios({
        methods: 'get',	
        url: urlName,
        headers: {
            'access-token': JSON.parse(localStorage.getItem("userInfo")).accessToken  
        },
        responseType: 'blob'
    }).then(res => {
        const blob = new Blob([res.data], {	
            type: 'application/octet-stream' 
        })
        let link = document.createElement('a')	
        let body = document.querySelector('body')
        link.href = window.URL.createObjectURL(blob) 

        link.download = filename // 自己制定下载文件的文件名
        // 兼容火狐浏览器
        link.style.display = 'none'	
        body.appendChild(link)
        link.click()		
        body.removeChild(link)	// 下载完成之后，移除按钮，垃圾回收，减少页面内存消耗
        window.URL.revokeObjectURL(link.href)	// 移除之前使用createObjectURL创建的URL，垃圾回收
    })
}
